import { useState,useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ModalCloseIcon } from "../../../assets/svg/close-modal.svg";
import { ReactComponent as MinusSign } from "../../../assets/svg/minus-sign.svg";
import { ReactComponent as PlusSign } from "../../../assets/svg/add-circle.svg";
import GuestImage from "../../../assets/svg/guest-photo.svg";
import { ReactComponent as TakePhoto } from "../../../assets/svg/take-photo.svg";
import { Container, Row, Col } from "react-bootstrap";
import "./visitor-create.css";
import { ReactComponent as CrossIcon } from "../../../assets/svg/close-1.svg";
import camera from "../../../assets/svg/camera.svg";

 const AddGuestModal = ({enabledFields,mandatoryFields,itemData, onSave,onCancel }) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
    const modalStyle = {
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          opacity: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        },
        modal: {
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          width: "718px",
          height:"478px",
          overflowY: "auto",
        },
      };


 const [loading, setLoading] = useState(false);
 const [image, setImage] = useState(null);
  const [guestName, setGuestName] = useState("");
  const [age, setAge] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [relationType, setRelationType] = useState("");
    const [proofType, setProofType] = useState("");
    const [proofNumber, setProofNumber] = useState("");
    useEffect(() => {
      if(itemData!=null){
        setImage(itemData.guest.image)
      setGuestName(itemData.guest.name);
      setAge(itemData.guest.age)
      setMobileNumber(itemData.guest.mobile_no)
      setRelationType(itemData.guest.type)
      setProofType(itemData.guest.proof_name)
      setProofNumber(itemData.guest.proof_value)
      }
     },[itemData]);   
   
     const isFieldEnabled=(field)=> {
      return enabledFields?.some(item => item === field);
    }
    const isFieldMandatory=(field)=> {
      return mandatoryFields?.some(item => item === field);
    }
    const [validations, setValidations] = useState({
      "image": "",
      "name": "",
      "mobile_no": "",
      "age": "",
      "type": "",
      "proof_name": "",
      "proof_value": "",
          });
       const [isCameraOpen, setIsCameraOpen] = useState(false);
       const videoRef = useRef(null);
       const streamRef = useRef(null);
     const canvasRef = useRef(null);
    
     useEffect(() => {
       
       if(isCameraOpen===true){
         setImage(null);
         getVideo();
       }
       
      },[isCameraOpen])
      const getVideo = () => {
       navigator.mediaDevices.enumerateDevices().then((devices) => {
         console.log("Devices start:", devices);
       });
     
       navigator.mediaDevices
           .getUserMedia({ video: true })
           .then(stream => {
               streamRef.current = stream;
               console.log(videoRef.current)
               if (videoRef.current) {
                   videoRef.current.srcObject = stream;
               }
           })
           .catch(err => {
               console.error("Error accessing camera:", err);
           });
     };
     const stopVideo = () => {
       console.log(streamRef.current);
       
       if (streamRef.current) {
         console.log(streamRef.current.getTracks());
           streamRef.current.getTracks().forEach(track => track.stop());
           streamRef.current = null;
          
       }
       console.log(videoRef.current);
       if (videoRef.current) {    
         videoRef.current.srcObject = null;
     }
       setIsCameraOpen(false);
       forceStopCamera()
     };
     const forceStopCamera = async () => {
       const devices = await navigator.mediaDevices.enumerateDevices();
     
       if (devices.some((device) => device.kind === "videoinput")) {
         const tempStream = await navigator.mediaDevices.getUserMedia({ video: true });
     
         tempStream.getTracks().forEach((track) => track.stop()); // Force stop
     
         console.log("Force-stopped extra video streams.");
       }
     };
       const captureImage = () => {
         const video = videoRef.current;
         const canvas = canvasRef.current;
         const context = canvas.getContext("2d");
     
         // Set canvas size to match video
         canvas.width = video.videoWidth;
         canvas.height = video.videoHeight;
     
         // Draw the video frame on the canvas
         context.drawImage(video, 0, 0, canvas.width, canvas.height);
     
         // Convert canvas to image URL
         const imageUrl = canvas.toDataURL("image/png");
         setImage(imageUrl);
       };    
         
    return ( <div style={modalStyle.overlay}>
        <div style={modalStyle.modal}>
          <div style={{ color: "#ffffff" }}>
            <div className="modal-header style-justify-between"
            >
              <div className="add-item-modal-title"
    >
    Add Guest 
    </div>
      <ModalCloseIcon
                style={{ cursor: "pointer" }}
                onClick={onCancel}
              />
            </div>

            <div style={{padding: "16px 24px",}}>
            {isFieldEnabled("Guest - Profile") && (<div>
            {isCameraOpen!==true && (<div className="style-justify-center" style={{gap:'16px'}}>
              <div>
                <img className="guest-image" src={image!=null && image!==''?image: GuestImage} alt="guest"/> 
              </div>
              <div>
              <div
                                        className="take-photo mt-2 style-justify-center"                          
                                        onClick={()=>{setIsCameraOpen(true);}}
                                      > 
                                      <TakePhoto/>
                                      <div>
                                      Take photo{isFieldMandatory("Guest - Profile") && (<span style={{color:'#FF4444'}}>*</span>)}  
                                        </div>
                                      </div>
                                      <span className="field-error" >{validations.image}</span>
                                      </div>
                                      
              </div>)}
              {isCameraOpen===true && (<div className="style-justify-center">  
                                  {image==null && (<div style={{position: 'relative',width: '150px',height: '150px',}}> 
                                    <video ref={videoRef} autoPlay playsInline style={{
                                              width: '150px',
                                              height: '150px',
                                              borderRadius: "7px",
                                              objectFit: 'cover',
                                              
                                          }}/>
                                          <div onClick={()=>{stopVideo()}} style={{position: 'absolute', top: '1px',right:'1px',}}>
                                            <CrossIcon/>
                                          </div>
                                          <div onClick={()=>{captureImage();setIsCameraOpen(false)}} style={{position: 'absolute', bottom: '1px',left:'10px',}}>
                                                  {/* <img src={camera} style={{width:'30px',height:'30px',margin:'0'}} /> */}
                                                  <div
                                        className="take-photo-camera mt-2 style-justify-center"                          
                                        
                                      > 
                                      <TakePhoto/>
                                      <div>
                                      Take photo
                                        </div>
                                      </div>
                                              
                                              </div>
                                          </div>)}
                                      <canvas ref={canvasRef} style={{ display: "none" }} />
                                  </div>)}
                                  </div>)}
            <Row>
            {isFieldEnabled("Guest - Name") && (<Col xs={12} sm={12} md={6} className="mt-3">
                <div className="field-title">
                      Name{isFieldMandatory("Guest - Name") && (<span style={{color:'#FF4444'}}>*</span>)} 
                    </div>
                  <input
                    type="text"
                    placeholder="Enter here"
                    className="input-field mt-2 w-100"
                    value={guestName}
                    onChange={(event) => {
                      setGuestName(event.target.value); // Update state with input value
                    }}
                  />
                  <span className="field-error" >{validations.name}</span>
                  </Col>)}
                  {isFieldEnabled("Guest - Age") && (<Col sm={12} lg={6} className="mt-3">
                                       <div className="field-title"> Age{isFieldMandatory("Guest - Age") && (<span style={{color:'#FF4444'}}>*</span>)}  </div>
                                       <div className="mt-1">
                                         <div>
                                           <input
                                             type="text"
                                             placeholder="Enter here "
                                             className="input-field w-100"
                                             value={age}
                                             onChange={(event) => {
                                               const value = event.target.value.replace(
                                                 /\D/g,
                                                 ""
                                               ); // Remove non-numeric characters
                                               setAge(value);
                                             }}
                                           />
                                         </div>                                         
                                       </div>
                                       <span className="field-error">{validations.age}</span>
                                     </Col>)} 
                                     {isFieldEnabled("Guest - Mobile number") && (<Col sm={12} lg={6} className="mt-3">
                                       <div className="field-title"> Mobile Number{isFieldMandatory("Guest - Mobile number") && (<span style={{color:'#FF4444'}}>*</span>)} </div>
                                       <div className="mt-1">
                                         <div>
                                           <input
                                             type="text"
                                             placeholder="Enter here "
                                             className="input-field w-100"
                                             value={mobileNumber}
                                             onChange={(event) => {
                                               const value = event.target.value.replace(
                                                 /\D/g,
                                                 ""
                                               ); // Remove non-numeric characters
                                               setMobileNumber(value);
                                             }}
                                           />
                                         </div>                                         
                                       </div>
                                       <span className="field-error">{validations.mobile_no}</span>
                                     </Col>)} 

                                     {isFieldEnabled("Guest - Type") && (<Col xs={12} sm={12} md={6} className="mt-3">
                <div className="field-title">
                      Relation Type{isFieldMandatory("Guest - Type") && (<span style={{color:'#FF4444'}}>*</span>)}
                    </div>
                  <input
                    type="text"
                    placeholder="Enter here"
                    className="input-field mt-2 w-100"
                    value={relationType}
                    onChange={(event) => {
                      setRelationType(event.target.value); // Update state with input value
                    }}
                  />
                  <span className="field-error" >{validations.type}</span>
                  </Col>)}
                  {isFieldEnabled("Guest - Proof") && (<Col sm={12} lg={6} className="mt-3">
                                  <div className="field-title">Proof{isFieldMandatory("Guest - Proof") && (<span style={{color:'#FF4444'}}>*</span>)} </div>
                                  <div className="mt-1">
                                    <div>
                                    <select className="select3 w-100 input-field" id="perpage" value={proofType}    onChange={(event) => { setProofType(event.target.value); }} style={{cursor:'pointer', fontSize: '14px',fontWeight: '500',lineHeight: '18.9px',color:'#8790A1',height:'40px',borderRadius:'10px',border:'0.7px solid #E5E5E5',padding: '0 8px',gap:'77px',backgroundColor:'#FFFFFF'}}>
                                            <option value="">Select</option>
                                            <option value="adahar">Aadhaar</option>
                                            <option value="pan">Pan</option>
                                            <option value="driving">Driving License</option>
                                            </select>
                                            <span style={{display: "flex", alignItems: "center", justifyContent: "start",fontSize: "12px",fontWeight: 400,color: "#FF4444", }}>{validations.proof_name}</span>
                                    </div>                       
                                  </div>
                                </Col>)}
                                {isFieldEnabled("Guest - Proof") && (<Col sm={12} lg={6} className="mt-3">
                                                      <div className="field-title">Proof Number{isFieldMandatory("Guest - Proof") && (<span style={{color:'#FF4444'}}>*</span>)}</div>
                                                      <div className="mt-1">
                                                        <div>
                                                        <input
                                                            style={{ width: "100%" }}
                                                            type="text"
                                                            placeholder="Enter here "
                                                            className="input-field"
                                                            value={proofNumber}
                                                            onChange={(event) => {
                                                              if(proofType==="adahar"){
                                                              const value = event.target.value.replace(
                                                                /\D/g,
                                                                ""
                                                              ); 
                                                              setProofNumber(value);
                                                            }else{
                                                              setProofNumber(event.target.value);
                                                            }
                                                            }}
                                                          />
                                                          <span style={{display: "flex", alignItems: "center", justifyContent: "start",fontSize: "12px",fontWeight: 400,color: "#FF4444", }}>{validations.proof_value}</span>
                                                        </div>                       
                                                      </div>
                                                    </Col>)}
                 
              </Row>
                            
               
              
           
              
             
              <Row className="mt-3"                
              >
                <div className="style-justify-end">
                <div
                  onClick={onCancel} className="cancel-modal-btn style-justify-center"                  
                >
                 Cancel
                </div>
                <div className="save-modal-btn style-justify-center"
                  onClick={ (e) => {
                    const tempValidation={
                      "image": "",
                      "name": "",
                      "mobile_no": "",
                      "age": "",
                      "type": "",
                      "proof_name": "",
                      "proof_value": "",
                          }

                    var isError=false;

                   if(isFieldMandatory("Guest - Profile") && image==null){
                    tempValidation["image"]="Guest profile photo required!";
                    isError=true;
                   } 
                   if(isFieldMandatory("Guest - Name") && guestName===""){
                    tempValidation["name"]="Guest name required!";
                    isError=true;
                   }
                   if(isFieldMandatory("Mobile number") && mobileNumber===""){
                    tempValidation["mobile_no"]="Guest mobile number required!";
                    isError=true;
                   }
                   if(isFieldMandatory("Guest - Age") && age===""){
                    tempValidation["age"]="Guest age required!";
                    isError=true;
                   }
                   if(isFieldMandatory("Guest - Type") && relationType===""){
                    tempValidation["type"]="Guest type required!";
                    isError=true;
                   }
                   if(isFieldMandatory("Guest - Proof") && proofType===""){
                    tempValidation["proof_name"]="Guest proof required!";
                    isError=true;
                   }
                   if(isFieldMandatory("Guest - Proof") && proofNumber===""){
                    tempValidation["proof_value"]="Guest proof number required!";
                    isError=true;
                   }
                   setValidations(tempValidation)
                   if(isError===false){
                     onSave({'guest':{
                      "image": image,
                      "name": guestName,
                      "mobile_no": mobileNumber,
                      "age": age,
                      "type": relationType,
                      "proof_name": proofType,
                      "proof_value": proofNumber,
                    },'index':itemData?.index??null}) 
                  }
                  }}>
                  Save
                </div>
                </div>
              </Row>
            </div>
          </div>
        </div>
      </div>);

}

export default AddGuestModal;